var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderTypeVirtualVisit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7611_31295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0551 19.9259C13.8605 19.9259 12.0757 18.141 12.0757 15.9464C12.0757 13.7518 13.8616 11.9658 16.0551 11.9658C18.2487 11.9658 20.0346 13.7518 20.0346 15.9464C20.0346 18.141 18.2497 19.9259 16.0551 19.9259ZM16.0551 12.5064C14.1589 12.5064 12.6162 14.0491 12.6162 15.9464C12.6162 17.8437 14.1589 19.3853 16.0551 19.3853C17.9514 19.3853 19.4941 17.8426 19.4941 15.9464C19.4941 14.0501 17.9514 12.5064 16.0551 12.5064Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8324 6.13216L14.1221 9.09324C14.0205 9.26946 14.1481 9.49 14.3513 9.49H17.7708C17.974 9.49 18.1016 9.26946 18 9.09324L16.2897 6.13216C16.1891 5.95595 15.9351 5.95595 15.8324 6.13216Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8324 25.7822L14.1221 22.8211C14.0205 22.6449 14.1481 22.4243 14.3513 22.4243H17.7708C17.974 22.4243 18.1016 22.6449 18 22.8211L16.2897 25.7822C16.1891 25.9584 15.9351 25.9584 15.8324 25.7822Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8886 15.7883L22.7156 13.957C22.5859 13.8824 22.4248 13.9753 22.4248 14.1245V17.7884C22.4248 17.9375 22.587 18.0316 22.7156 17.9559L25.8886 16.1245C26.0183 16.0499 26.0183 15.864 25.8886 15.7883Z",
    fill: "#12181E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13297 15.7279L9.09405 14.0176C9.27027 13.916 9.49081 14.0436 9.49081 14.2468V17.6663C9.49081 17.8696 9.27027 17.9971 9.09405 17.8955L6.13297 16.1852C5.95568 16.0846 5.95568 15.8295 6.13297 15.7279Z",
    fill: "#12181E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7611_31295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderTypeVirtualVisit);
export default __webpack_public_path__ + "static/media/order_type_virtual_visit.bb0d803b54fadb2378c43ac473e4f2d6.svg";
export { ForwardRef as ReactComponent };